import { makeDataResource, makePermission, } from './permission';
function makeState() {
    const { permission, } = makePermission({
        role_ids: [],
        current_resource_infos: [],
    });
    const { resource: dataResource, } = makeDataResource();
    return {
        permission,
        dataResource,
    };
}
export const PermissionModule = {
    namespaced: true,
    state: makeState(),
    getters: {},
    mutations: {
        updatePermissions(state, info) {
            const { permission, } = makePermission(info);
            state.permission = permission;
        },
        updateDataPermissions(state, data) {
            const { resource, } = makeDataResource(data);
            state.dataResource = resource;
        },
    },
};
